/**
 *
 * Asynchronously loads the component for EnrollDeliveriesPage
 *
 */

import { lazyLoad } from "utils/loadable"

export const EnrollDeliveriesPage = lazyLoad(
  () => import("./index"),
  module => module.EnrollDeliveriesPage,
)
